import React from 'react';
import { BoxplotChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";
import './_index.scss'

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const chartOptions = {
                    ...buildXYChartOptions(chart, { bottomMapsTo: 'group' }),
                    color: { scale: colorScale }
                };
                return <BoxplotChart options={chartOptions} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
